import React, { Component } from 'react';
import { render } from 'react-dom';

class AddFishForm extends Component {

	createFish(event) {
		event.preventDefault();
		console.log('fish')
		const fish = {
			name: this.name.value,
			price: this.price.value,
			status: this.status.value,
			desc: this.desc.value,
			image: this.image.value
		}
		this.props.addFish(fish);
		this.fishForm.reset();
	}



	render() {
		// Comment
		return (
			<form ref={(input) => this.fishForm = input} className="fish-edit" onSubmit={(e) => this.createFish(e)}>
				{ /* Above function is another way of binding method to component */ }
				<input ref={(input) => this.name = input} type="text" placeholder="Fish Name"/>
				<input ref={(input) => this.price = input} type="text" placeholder="Fish Price"/>
				<select ref={(input) => this.status = input}>
					<option value="available">Fresh!</option>
					<option value="unavailable">Sold out!</option>
				</select>
				<textarea ref={(input) => this.desc = input} placeholder="Fish Desc"></textarea>
				<input ref={(input) => this.image = input} type="text" placeholder="Fish Image"/>
				<button type="submit">+ Add Item</button>
			</form>
		)
	}
}


AddFishForm.propTypes = {
	addFish: React.PropTypes.func.isRequired
}

export default AddFishForm;


/** WEBPACK FOOTER **
 ** ./src/components/AddFishForm.js
 **/